<template>
    <div class="piccon">
        <ul class="ul">
            <li v-for="(item, index) in fileLists" :key="index">
                <img :src="item.url" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0"  @click="scale($event)">
                <video :src="item.url" v-else-if="item.type&&item.type.indexOf('video')>=0" controls preload="auto" style="object-fit:fill" webkit-playsinline="true" >
                <!-- <video :src="item.url" v-if="item.type&&item.type.indexOf('video')>=0" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video> -->
                
                </video>
                <div style="width:100%;height:100%;position:relative" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i></div>
                <div class="mask" v-if="item.loading">
                    <i class="icon el-icon-loading"></i>
                </div>
                <div class="close" @click="handleRemove(item)">
                    <i class="el-icon-close"></i>
                </div>
            </li>

        </ul>
        <div class="picdefault" @click="handleClick">
            <i class="icon el-icon-plus"></i>
            <input type="file" name="file" id="" multiple ref="uploadInput" @change="handleChange($event)" class="uploadInput">
        </div>
    </div>
</template>
<script>

import axios from '@/utils/api.request'
import { Toast } from 'mint-ui'
import { getImg, getVideo } from '@/api/case'
import Global from '@/config/global.js'

export default {
    name: "Upload",
    props: [ 'filename', 'url', 'fileList', 'attac' ],
    data() {
        return {
            attachmentIdss: this.attac,
            sub: false,
            fileLists: this.fileList
        }
    },
    created() {
        this.$emit("changeAttach",this.attac)
    },
    methods: {
        scale(e) {
            if(e.target.style.position == "fixed"){
                e.target.style.position = "static"
                e.target.style.height = '100%'
            }else{
                e.target.style.position = "fixed"
                e.target.style.top = "0"
                e.target.style.bottom = 0
                e.target.style.marginTop = 'auto'
                e.target.style.marginBottom = 'auto'
                e.target.style.left = 0
                e.target.style.zIndex = '1000'
                e.target.style.height = 'auto'
            }
        },
        handleClick() {
            this.$refs.uploadInput.click();
        },
        handleChange(val) {
            //预览功能
            var filename = this.filename ? this.filename : 'file'
            if(window.FileReader) {
                var reader = new FileReader
            }else {
                alert("您的设备不支持图片预览功能，如需该功能请升级您的设备！");
                return false;
            }
            // var file = val.target.files[0];
            // if(file.type.indexOf('image'>=0)){
            //     reader.readAsDataURL(file);
            //     reader.onload = function(e) {
            //         let json = {
            //             id: 0,
            //             name: file.name,
            //             url: e.target.result,
            //             loading: true,
            //         }
            //         this.fileLists.push(json)
            //     }.bind(this)
            //     // 上传功能
            //     var formdata=new FormData();
            //     formdata.append(filename, file);
            // }
            for(let i=0;i<val.target.files.length;i++){
                console.log(i)
                let file = val.target.files[i];
                console.log(file)
                let json = {
                    id: 0,
                    name: file.name,
                    loading: true,
                }
                this.fileLists.push(json)
                this.upload(file)
            }

            // this.upload(file)
            //formdata.append('uploadImage',$('#uploadImage').get(0).files[0]);
        },
        upload(fileObj) {
            const formData = new FormData()
            formData.append('file', fileObj)
            this.sub = true
            this.$emit("sub1",this.sub)
            return axios.request({
                url: this.url,
                method: 'post',
                data: formData
            }).then(this.handleUpload, this.handleUploadError)
        },
        handleUpload(res) {
            console.log(res)
            this.fileLists.forEach(v => {
                if(v.name == res.data.data.rawName) {
                    console.log(res)
                    v.id = res.data.data.id
                    v.url = res.data.data.url
                    v.type = res.data.data.fileType
                    v.loading = false
                    if(v.type.indexOf('image')>=0) {
                        getImg(res.data.data.url).then(resp=>{
                            console.log(resp)
                            var mimeType = res.data.data.mime.toLowerCase();
                            //var mimeType = 'image/png'
                            var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                            v.url = 'data:' + mimeType + ';base64,' + imgBase64;
                            Toast({
                                message: '上传成功',
                                position: 'top',
                            });
                        },err => {
                            Toast({
                                message: '上传失败',
                                position: 'top',
                            })})
                    }else if(v.type.indexOf('video')>=0) {
                        v.url = Global.server_api + res.data.data.url;
                        // getVideo(res.data.data.url).then(resp=>{
                        //      v.url = URL.createObjectURL(resp.data)
                        //     console.log(resp)
                        //     Toast({
                        //         message: '上传成功',
                        //         position: 'top',
                        //     });
                        // },err => {
                        //     console.log(err)
                        //     Toast({
                        //         message: '上传失败',
                        //         position: 'top',
                        //     });
                        // })
                    }

                    this.attachmentIdss.push({id : res.data.data.id, name : res.data.data.rawName})
                    this.sub = false
                    console.log(this.attachmentIdss)
                    this.$emit("changeAttach",this.fileLists)
                    this.$emit("sub1",this.sub)
                }

            })

        },
        handleRemove(file, fileList) {
            console.log(file)
            this.fileLists.forEach((v, i) => {
                if(v.name == file.name){
                    this.fileLists.splice(i,1)
                    this.attachmentIdss.splice(i,1)
                }
            })
            console.log(this.attachmentIdss)
            this.$emit("changeAttach",this.fileLists)
            this.sub = false
            this.$emit("sub1",this.sub)
        },

    }
}
</script>
<style scoped>
    .picdefault {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: none;
        font-size: 2em;
        color: #8c939d;
    }
    .picdefault i{
        font-size: 24px;
    }
    .uploadInput {
        display: none;
    }
    .picture, video {
        width: 100%;
        height: 100%;
        display: inline-block;
    }
    .ul {
        display: inline;
    }
    .ul li{
        width: 148px;
        height: 148px;
        display: inline-block;
        margin-right: 3%;
        margin-bottom: 3%;
        overflow: hidden;
        position: relative;
    }
    .piccon {
        width: 100%
    }
    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        text-align: center;
        line-height: 148px;
        font-size: 36px;
    }
    .mask i {
        font-size: 30px;
    }
    .close {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        font-size: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
    }

</style>
